/* Program Name: cartAPi.js
 **  Description: a collection of functions that handle the direct AJAX calls
 **               for all things Cart.
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2022-03-21  STT  Initial program
 ** SD9567     2026-02-02  SGS  ITSM-517 - Expose CC Expiration Dates for Call Center
 *********************************************************************************/

/**importing the baseurl from Axios */
import { setData } from '../../API/generalAPI'
import TS from '../../API/TS'

/** Get Menus =>
 * AJAX call to get all the menus
 */
export const getCart = () => {
  return TS.post('/shop/cart_rdr', setData({ ttRequest: [{ mode: 'all' }] }))
}

export const getCartErrors = (id, origin) => {
  return TS.post(
    '/shop/cart_rdr',
    setData({ ttRequest: [{ mode: 'error', cartId: id, pageOrigin: origin }] })
  )
}

export const getCartOptions = () => {
  return TS.post(
    '/shop/cart_rdr',
    setData({ ttRequest: [{ mode: 'options' }] })
  )
}

export const getCartCheckout = () => {
  return TS.post(
    '/shop/cart_checkout',
    setData({ ttRequest: [{ mode: 'checkout' }] })
  )
}

export const getCartUsers = () => {
  return TS.post(
    '/shop/cart_rdr',
    setData({ ttRequest: [{ mode: 'handoff' }] })
  )
}

export const getMyCarts = () => {
  return TS.post(
    '/shop/cart_rdr',
    setData({ ttRequest: [{ mode: 'mycarts' }] })
  )
}

export const updateCartPay = (pay) => {
  return TS.post(
    '/shop/cart_upd',
    setData({ ttRequest: [{ mode: 'upd_pay', scope: 'cart', payMeth: pay }] })
  )
}

export const updateLocPay = (pay, id) => {
  return TS.post(
    '/shop/cart_upd',
    setData({
      ttRequest: [
        { mode: 'upd_pay', scope: 'location', payMeth: pay, cartLocId: id },
      ],
    })
  )
}

export const deleteCart = () => {
  return TS.post(
    'shop/cart_upd',
    setData({ ttRequest: [{ mode: 'delete', scope: 'cart' }] })
  )
}

export const deleteSpecCart = (id) => {
  return TS.post(
    'shop/cart_upd',
    setData({ ttRequest: [{ mode: 'delete', scope: 'speccart', cartId: id }] })
  )
}

export const deleteLocOrder = (id) => {
  return TS.post(
    'shop/cart_upd',
    setData({
      ttRequest: [{ mode: 'delete', scope: 'location', cartLocId: id }],
    })
  )
}

export const deleteLine = (id) => {
  return TS.post(
    'shop/cart_upd',
    setData({ ttRequest: [{ mode: 'delete', scope: 'line', cartLineId: id }] })
  )
}

export const updateCartAddress = (addr) => {
  return TS.post(
    'shop/cart_upd',
    setData({ ttRequest: [{ mode: 'upd_addr', scope: 'cart', addrId: addr }] })
  )
}

export const updateLocAddress = (addr, id) => {
  return TS.post(
    'shop/cart_upd',
    setData({
      ttRequest: [
        { mode: 'upd_addr', scope: 'location', addrId: addr, cartLocId: id },
      ],
    })
  )
}

export const updateCartShip = (ship) => {
  return TS.post(
    'shop/cart_upd',
    setData({
      ttRequest: [{ mode: 'upd_ship', scope: 'cart', shipMeth: ship }],
    })
  )
}

export const updateLocShip = (ship, id) => {
  return TS.post(
    'shop/cart_upd',
    setData({
      ttRequest: [
        { mode: 'upd_ship', scope: 'location', shipMeth: ship, cartLocId: id },
      ],
    })
  )
}

export const updateCartCategory = (cat) => {
  return TS.post(
    'shop/cart_upd',
    setData({ ttRequest: [{ mode: 'upd_cat', scope: 'cart', catCode: cat }] })
  )
}

export const updateLocCategory = (cat, id) => {
  return TS.post(
    'shop/cart_upd',
    setData({
      ttRequest: [
        { mode: 'upd_cat', scope: 'location', catCode: cat, cartLocId: id },
      ],
    })
  )
}

export const updateLocCatReason = (reason, id) => {
  return TS.post(
    'shop/cart_upd',
    setData({
      ttRequest: [
        {
          mode: 'upd_reason',
          scope: 'location',
          catReason: reason,
          cartLocId: id,
        },
      ],
    })
  )
}

export const addEmail = (email) => {
  return TS.post(
    'shop/cart_upd',
    setData({ ttRequest: [{ mode: 'upd_email', scope: 'cart', email: email }] })
  )
}

export const deleteEmail = (email) => {
  return TS.post(
    'shop/cart_upd',
    setData({ ttRequest: [{ mode: 'del_email', scope: 'cart', email: email }] })
  )
}

export const updateLineQty = (qty, id) => {
  return TS.post(
    'shop/cart_upd',
    setData({
      ttRequest: [{ mode: 'upd_qty', scope: 'line', cartLineId: id, qty: qty }],
    })
  )
}

export const addNewAddress = (addr, id) => {
  return TS.post(
    'shop/cart_upd',
    setData({
      ttRequest: [{ mode: 'add_addr', scope: 'location', cartLocId: id }],
      ttAddress: [addr],
    })
  )
}

export const addNewCartAddress = (addr) => {
  return TS.post(
    'shop/cart_upd',
    setData({
      ttRequest: [{ mode: 'add_addr', scope: 'cart' }],
      ttAddress: [addr],
    })
  )
}

export const completeCheckout = () => {
  return TS.post(
    '/shop/cart_checkout',
    setData({ ttRequest: [{ mode: 'complete' }] })
  )
}

export const passCart = (id) => {
  return TS.post(
    '/shop/cart_upd',
    setData({ ttRequest: [{ mode: 'givecart', scope: 'cart', userId: id }] })
  )
}

export const takeCart = (id) => {
  return TS.post(
    '/shop/cart_upd',
    setData({ ttRequest: [{ mode: 'takecart', scope: 'cart', cartId: id }] })
  )
}

export const activateCart = (id) => {
  return TS.post(
    '/shop/cart_upd',
    setData({ ttRequest: [{ mode: 'activate', scope: 'cart', cartId: id }] })
  )
}

export const saveCart = () => {
  return TS.post(
    '/shop/cart_upd',
    setData({ ttRequest: [{ mode: 'save', scope: 'cart' }] })
  )
}
